import { DialogComponent } from '@theme/dialog';
import { CartAddEvent } from '@theme/events';

/**
 * A custom element that manages a cart drawer.
 *
 * @extends {DialogComponent}
 */
class CartDrawerComponent extends DialogComponent {
  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(CartAddEvent.eventName, this.#handleCartAdd);
    this.addEventListener('click', this.#handleUpsellSlide);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(CartAddEvent.eventName, this.#handleCartAdd);
    this.removeEventListener('click', this.#handleUpsellSlide);
  }

  #handleCartAdd = () => {
    if (this.hasAttribute('auto-open')) {
      this.showDialog();
    }
  };

  #handleUpsellSlide = (event) => {
    this.slideUpsell(event);
  };

  slideUpsell(event) {
    const target = /** @type {HTMLElement} */ (event.target);
    const button = target.closest('[data-upsell-direction]');
    const slider = button?.closest('.drawer-upsell-block')?.querySelector('.drawer-upsell-grid');

    if (!slider) return;

    event.preventDefault();
    event.stopPropagation();

    const firstItem = slider.querySelector('.drawer-upsell-item');
    const scrollAmount = firstItem instanceof HTMLElement ? firstItem.offsetWidth + 12 : slider.clientWidth;

    slider.scrollBy({
      left: scrollAmount * Number(button.dataset.upsellDirection),
      behavior: 'smooth',
    });
  }

  open() {
    this.showDialog();

    /**
     * Close cart drawer when installments CTA is clicked to avoid overlapping dialogs
     */
    customElements.whenDefined('shopify-payment-terms').then(() => {
      const installmentsContent = document.querySelector('shopify-payment-terms')?.shadowRoot;
      const cta = installmentsContent?.querySelector('#shopify-installments-cta');
      cta?.addEventListener('click', this.closeDialog, { once: true });
    });
  }

  close() {
    this.closeDialog();
  }
}

if (!customElements.get('cart-drawer-component')) {
  customElements.define('cart-drawer-component', CartDrawerComponent);
}
